import React, { useState, useEffect } from 'react';
import {
    createCatalog,
    getCatalog,
    updateCatalog,
    updateCategories
} from "../../store/action/catalog";
import { isAuthenticated } from "../../store/action/auth";
import Modal from "../../components/molecules/Modal";
import CatalogForm from "../../components/forms/CatalogForm";
import { getAddresses } from "../../store/action/address";
import _ from 'lodash';
import ProductTable from "../../components/tables/ProductTable";
import LoadingBar from "react-top-loading-bar";
import ProductForm from "../../components/forms/ProductForm";
import {
    createProduct,
    updateProduct,
    deleteProduct,
    updateProductImage
} from "../../store/action/product";
import {
    isContainNumber,
    isContainText
} from "../../services/helpers/validator";
import PaymentWarning from "../../components/warnings/Payment";
import Freshchat from "../../components/atoms/FreshChat";

const Inventory = () => {
    const { user, token } = isAuthenticated();
    const [ addresses, setAddresses ] = useState([]);
    const [ show, setShow ] = useState({
        modal: false,
        modalType: ''
    });
    let catalogInitial = {
        addressName:'',
        addressPhone:'',
        addressDetails:'',
        addressCoordinate:{},
        addressNote:'',
        category:'',
        categories:[],
        catalogId: '',
        description: '',
        link: '-',
        organizationId: '',
        products: [],
        productId:'',
        productName: '',
        productPrice: '',
        productDetails: '',
        productImage: '',
        productLength:0,
        productHeight:0,
        productWidth:0,
        productWeight:0,
        productCategory:'',
        productSku:'',
        productStock:0,
        productStatus: 'active',
        subtitle: '',
        status: '',
        style: {},
        title: '',
        userId: ''
    };
    const [ catalog, setCatalog ] = useState(catalogInitial);
    const [ newCatalog, setNewCatalog ] = useState(catalogInitial);
    const [ categories, setCategories ] = useState([]);
    const [ values, setValues] = useState(({
        error:false,
        info:'',
        pageLoading:true,
        productSubmitLoading:false,
        progress:0,
        success:false
    }));

    useEffect(() => {
        _fetchData()
    }, []);

    const _fetchData = async () => {
        setValues({...values, pageLoading:true});
        try {
            const resCat = await getCatalog(token);
            const resAd = await getAddresses(token);
            if (resCat.success && resAd.success && resAd.addresses.length > 0 ) {
                let resAddresses = resAd.addresses.reduce((result, i) => {
                    result.push({
                        addressName:i.name,
                        addressPIC:i.PIC,
                        addressDetails: i.details,
                        addressNote:i.note,
                        coordinate:i.coordinate,
                        postalCode: i.postalCode,
                        provinceId: i.provinceId,
                        provinceName: i.provinceName,
                        cityId: i.cityId,
                        cityName: i.cityName,
                        districtId: i.districtId,
                        districtName: i.districtName,
                        subdistrictId: i.subdistrictId,
                        subdistrictName: i.subdistrictName
                    });
                    return result
                }, []);

                if (resAd.addresses.length === 0) {
                    setAddresses([]);
                } else {
                    setAddresses ( resAddresses );
                }

                if (_.isEmpty(resCat.catalog)){
                    let catData = {
                        addressName:resAddresses[0].addressName,
                        addressPhone:resAddresses[0].addressPIC,
                        addressDetails:resAddresses[0].addressDetails,
                        addressCoordinate:resAddresses[0].coordinate,
                        addressNote:resAddresses[0].addressNote
                    };
                    setCatalog({...catalog, ...catData });
                    setNewCatalog({...newCatalog, ...catData });
                } else {
                    setCatalogResponse(resCat)
                }
            }
            setValues({
                ...values,
                pageLoading:false
            })
        } catch (e) {
            console.log (e);
            alert(`Maaf. Gagal ambil data katalog.`)
            setValues({
                ...values,
                pageLoading:false
            })
        }
    };

    const setCatalogResponse = (resCat) => {
        setCategories(resCat.catalog.categories);
        setCatalog({
            ...catalog,
            addressName:resCat.catalog.address.name,
            addressPhone:resCat.catalog.address.phone,
            addressDetails:resCat.catalog.address.location,
            addressCoordinate:resCat.catalog.address.coordinate,
            addressNote:resCat.catalog.address.note,
            catalogId: resCat.catalog._id,
            categories: resCat.catalog.categories,
            createdAt: resCat.catalog.createdAt,
            description: resCat.catalog.description,
            link: resCat.catalog.link,
            organizationId: resCat.catalog.organizationId,
            products: resCat.catalog.products,
            status: resCat.catalog.status,
            subtitle: resCat.catalog.subtitle,
            style: resCat.catalog.style,
            title: resCat.catalog.title,
            updatedAt: resCat.catalog.updatedAt,
            userId: resCat.catalog.userId
        });
        setNewCatalog({
            ...newCatalog,
            categories: resCat.catalog.categories,
            subtitle: resCat.catalog.subtitle,
            title: resCat.catalog.title,
            style: resCat.catalog.style,
            addressName:resCat.catalog.address.name,
            addressPhone:resCat.catalog.address.phone,
            addressDetails:resCat.catalog.address.location,
            addressCoordinate:resCat.catalog.address.coordinate,
            addressNote:resCat.catalog.address.note,
            productCategory: resCat.catalog.categories[0]
        });
    };

    const handleModalClose = () => {
        setShow({
            ...modal,
            modal:false
        });
        setNewCatalog({
            ...newCatalog,
            productName: '',
            productPrice: '',
            productDetails: '',
            productSku: '',
            productImage: '',
            productLength:0,
            productHeight:0,
            productWidth:0,
            productWeight:0,
            productCategory:'',
        })
    };

    const handleModalShow = (type) => {
        if (!user.phone ) {
            alert("Mohon masukkan nomor telepon terlebih dahulu di bagian pngaturan");
            return
        }
        if (!user.organizationName) {
            alert("Mohon masukkan nama perusahaan terlebih dahulu di bagian pengaturan");
            return
        }

        setShow({
            modal:true,
            modalType: type
        });
    };

    const handleProductChange = name => e => {
        const value = e.target.value;
        setNewCatalog({ ...newCatalog, [name]: value });
        setValues({...values, error: ''})
    };

    const handleCatalogChange = name => e => {
        const value = e.target.value;
        setNewCatalog({ ...newCatalog, [name]: value });
        setValues({...values, error: ''})
    };

    const handleCategoryChange = name => e => {
        const value = e.target.value;
        setNewCatalog({ ...newCatalog, [name]: value });
        setValues({...values, error: ''})
    };

    const handleAddressChange = async (a) => {
        let address = {
            addressName:a.addressName,
            addressDetails:a.addressDetails,
            addressPhone:a.addressPIC,
            addressNote:a.addressNote,
            addressCoordinate: {
                latitude: a.coordinate.latitude,
                longitude: a.coordinate.longitude
            }
        };
        setNewCatalog({
            ...newCatalog,
            ...address
        })
    };

    const onEditProduct = (product) => {
        handleModalShow('editProduct');
        setNewCatalog({
            ...newCatalog,
            ...product
        })
    };


    const onStatusProduct = async (product) => {
        let data = {
            productId: product.productId,
            name: product.productName,
            sku: product.productSku,
            details: product.productDetails,
            category: product.productCategory,
            image: product.productImage,
            length: product.productLength,
            width: product.productWidth,
            height: product.productHeight,
            weight: product.productWeight,
            price: product.productPrice,
            stock: product.productStock,
            status: product.productStatus
        };
        let resProd = await updateProduct(token, data);
        try {
            if (resProd.success) {
                setCatalogResponse(resProd)
            } else {
                setValues({
                    ...values,
                    info:'',
                    error: resProd.error,
                    productSubmitLoading: false
                });
                alert("Produk gagal diupdate.");
            }
        } catch (e) {
            console.log (e);
            setValues({
                ...values,
                info:'',
                error: resProd.error,
                productSubmitLoading: false
            });
            alert("Produk gagal diupdate.");
        }
    };

    const onSelectImageProduct = async (e) => {
        const data = e.target.files[0];
        const res = await updateProductImage(token, data);
        if(res.success) {
            alert("Foto produk telah diupdate");
            setNewCatalog({
                ...newCatalog,
                productImage: res.image
            })
        } else {
            alert("Foto produk gagal diupadte. Coba ulangi lagi yuk!")
        }
    };

    const onAddCategory = async () => {
        if (!newCatalog.category) {
            alert("Kategori masih kosong");
            return
        }
        let copyCategory = newCatalog.category;
        let copyCategories = newCatalog.categories;
        copyCategories.push(copyCategory);

        setCatalog({
            ...catalog,
            categories: []
        });

        setNewCatalog({
            ...newCatalog,
            category: '',
            categories: copyCategories,
            productCategory: newCatalog.category
        })
    };

    const onRemoveCategory = async (category) => {
        let copyCategories = newCatalog.categories;
        let filteredCategories = copyCategories.filter(i => i !== category);
        setNewCatalog({
            ...newCatalog,
            category: '',
            categories: filteredCategories
        })
    };

    const onSubmitNewCategories = async () => {
        const resCat = await updateCategories(token, catalog.catalogId, {categories: newCatalog.categories});
        if (resCat.success){
            alert("Kategori berhasil disimpan");
            window.location.reload()
        } else {
            alert("Gagal update kategori")
        }
    };

    const onSubmitNewCatalog = async () => {
        if (!newCatalog.title) {
            alert("Mohon masukkan nama brand kamu dulu ya :)");
            return
        }

        if (!newCatalog.addressName) {
            alert("Mohon masukkan alamat kamu dulu ya :)");
            return
        }

        let nc = {
            catalogTitle: newCatalog.title,
            catalogSubtitle: newCatalog.subtitle,
            catalogDescription: newCatalog.description,
            catalogStyle: newCatalog.style,
            addressName: newCatalog.addressName,
            addressDetails: newCatalog.addressDetails,
            addressPhone: newCatalog.addressPhone,
            addressNote: newCatalog.addressNote,
            addressCoordinate:  newCatalog.addressCoordinate,
            status: 'active'
        };

        let resCat;
        if (show.modalType === 'edit') {
            resCat = await updateCatalog(token, catalog.catalogId, nc);
        } else {
            resCat = await createCatalog(token, nc );
        }

        if (resCat.success) {
            alert("Katalog berhasil dibuat.");
            window.location.reload()
        } else {
            alert("Katalog gagal dibuat. Mohon ulangi kembali.")
        }
    };

    const onEditCategory = async () => {
        setNewCatalog({
            ...newCatalog,
            productCategory: catalog.categories[0]
        })
    };

    const onSubmitProduct = async (type) => {
        let resProd;
        const checkName = await isContainText('Nama barang',newCatalog.productName);
        if (!checkName .success) return setValues({...values, error: checkName.message});
        const checkPrice = await isContainText('Harga barang',newCatalog.productPrice);
        if (!checkPrice .success) return setValues({...values, error: checkPrice.message});
        const checkStock = await isContainNumber('Stok barang',newCatalog.productStock);
        if (!checkStock .success) return setValues({...values, error: checkStock.message});
        if (!newCatalog.productLength || !newCatalog.productWidth || !newCatalog.productHeight || !newCatalog.productWeight) {
            return setValues({...values, error: 'Dimensi atau berat barang masih kosong. Mohon diisi.'})
        }

        if (type === 'new') {
            setValues({
                ...values,
                info:'Membuat produk baru...',
                productSubmitLoading: true
            });
        } else {
            setValues({
                ...values,
                info:'Menyimpan editan produk...',
                productSubmitLoading: true
            });
        }

        try {
            let data = {
                productId: newCatalog.productId,
                name: newCatalog.productName,
                sku: newCatalog.productSku,
                details: newCatalog.productDetails,
                category: newCatalog.productCategory,
                image: newCatalog.productImage,
                length: newCatalog.productLength,
                width: newCatalog.productWidth,
                height: newCatalog.productHeight,
                weight: newCatalog.productWeight,
                price: newCatalog.productPrice,
                stock: newCatalog.productStock,
                status: newCatalog.productStatus
            };
            if (type === 'new') {
                resProd = await createProduct(token, data)
            } else {
                resProd = await updateProduct(token, data)
            }

            if (resProd.success) {
                if (type === 'new') {
                    alert("Produk berhasil dibuat.");
                } else {
                    alert("Produk berhasil diedit.");
                }
                window.location.reload()
            } else {
                setValues({
                    ...values,
                    info:'',
                    error: resProd.error,
                    productSubmitLoading: false
                });
                alert("Produk gagal dibuat.");
            }
        } catch (e) {
            console.log (e);
            setValues({
                ...values,
                info:'',
                error: resProd.error,
                productSubmitLoading: false
            });
            alert("Produk gagal dibuat.");
        }
    };

    const onRemoveProduct = async (productId) => {
        try {
            let resProd;
            if(window.confirm('Kamu yakin mau delete produk?')){
                resProd = await deleteProduct(token, productId);
                if (resProd.success) {
                    alert("Produk berhasil didelete.");
                    window.location.reload()
                } else {
                    alert("Produk gagal didelete. Mohon ulangi kembali.");
                }
            }

        } catch (e) {
            console.log (e);
            alert("Produk gagal didelete.");
        }
    };

    const showError = () => (
        <div
            className="alert alert-danger mb-0"
            style={{display: values.error ? '' : 'none'}}
        >
            { values.error }
        </div>
    );

    const showInfo = () => (
        <div
            className="alert alert-info mb-0"
            style={{display: values.info ? '' : 'none'}}
        >
            { values.info }
        </div>
    );

    const modal = () => {
        let body, title, bText, bClick, size, type, lbClick, rbClick;
        if (show.modalType === 'new' || show.modalType === 'edit') {
            if ( show.modalType === 'new') {
                title = `Buat Katalog Baru`;
                bText = `Buat Baru`
            } else {
                title =  `Edit Katalog`;
                bText = `Simpan`
            }
            lbClick = () => handleModalClose();
            rbClick = () => onSubmitNewCategories();
            type = 'oneButton';
            size = 'md';
            bClick = () => onSubmitNewCatalog();
            body = (
                <div className="p-4">
                    <CatalogForm
                        addresses={addresses}
                        handleCatalogChange={handleCatalogChange}
                        handleAddressChange={handleAddressChange}
                        type={show.modalType}
                        oldValues={catalog}
                        newValues={newCatalog}
                    />
                </div>
            )
        } else if (show.modalType === 'editCategory') {
            lbClick = () => handleModalShow('addProduct');
            rbClick = () => onSubmitNewCategories();
            type = 'yesno';
            title = `Edit Kategori`;
            body = (
                <div className="p-4">
                    <h6>Kategori Katalog Saya</h6>
                    <div>
                        {
                            newCatalog.categories.map((i,idx) => (
                                <div key={idx} className="pl-4 py-1 d-flex justify-content-between bg-lighter mb-1">
                                    <b className="pt-1">{i}</b>
                                    <a onClick={() => onRemoveCategory(i)}
                                       className="action-item mr-2"
                                       data-toggle="tooltip"
                                       title="Remove">
                                        <i className="fas fa-times"></i>
                                    </a>
                                </div>
                            ))
                        }
                    </div>
                    <div className="input-group mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Nama Kategori"
                            onChange={handleCategoryChange('category')}
                            value={newCatalog.category}
                        />
                        <div className="input-group-append">
                            <button
                                onClick={onAddCategory}
                                className="btn btn-outline-primary"
                                type="button"
                            >
                                Tambah
                            </button>
                        </div>
                    </div>
                </div>
            )
        } else if (show.modalType === 'addProduct') {
            lbClick = () => handleModalClose();
            type = 'yesno';
            size = 'md';
            // catcatcat
            if (catalog.categories.length === 0 ) {
                rbClick = () => onSubmitNewCategories();
                title = `Tambah Kategori`;
                body = (
                    <div className="p-4">
                        <h6>Kategori produk masih kosong. Tambah dulu ya!</h6>
                        <div>
                            {
                                newCatalog.categories.map((i,idx) => (
                                    <div key={idx} className="pl-4 py-1 d-flex justify-content-between bg-lighter mb-1">
                                        <b className="pt-1">{i}</b>
                                        <a onClick={() => onRemoveCategory(i)}
                                           className="action-item mr-2"
                                           data-toggle="tooltip"
                                           title="Remove">
                                            <i className="fas fa-times"></i>
                                        </a>
                                    </div>
                                ))
                            }
                        </div>
                        <div className="input-group mb-3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Nama Kategori"
                                onChange={handleCategoryChange('category')}
                                value={newCatalog.category}
                            />
                            <div className="input-group-append">
                                <button
                                    onClick={() => onAddCategory()}
                                    className="btn btn-outline-primary"
                                    type="button"
                                >
                                    Tambah
                                </button>
                            </div>
                        </div>
                    </div>
                )
            } else {
                rbClick = () => onSubmitProduct('new');
                lbClick = () => handleModalClose();
                type = 'yesno';
                size = 'lg';
                title = `Tambah Produk`;
                body = (
                    <ProductForm
                        className="p-4"
                        loading={values.productSubmitLoading}
                        handleChange={handleProductChange}
                        categories={categories}
                        onClickEditCategories={() => handleModalShow('editCategory')}
                        onProductImageSelect={onSelectImageProduct}
                        values={newCatalog}
                    />
                )
            }
        } else if (show.modalType === 'editProduct') {
            type = 'yesno';
            size = 'lg';
            lbClick = () => handleModalClose();
            rbClick = () => onSubmitProduct('edit');
            title = `Edit Produk`;
            body = (
                <ProductForm
                    className="p-4"
                    loading={values.productSubmitLoading}
                    handleChange={handleProductChange}
                    categories={categories}
                    onClickEditCategory={onEditCategory}
                    onClickEditCategories={() => handleModalShow('editCategory')}
                    onProductImageSelect={onSelectImageProduct}
                    values={newCatalog}
                />
            )
        } else {
            body = (
                <div>Loading...</div>
            )
        }

        return (
            <Modal
                bodyClassName="p-0"
                show={show.modal}
                size={size}
                onHide={handleModalClose}
                title={title}
                type={type}
                buttons
                footerStyle={{justifyContent:'flex-end'}}
                lbText="Kembali"
                lbClick={lbClick}
                rbText="Simpan"
                rbClick={rbClick}
                bText={bText}
                bClick={bClick}
            >
                { showError() }
                { showInfo() }
                { body }
            </Modal>
        )
    };

    let catalogView;
    if (catalog.catalogId) {
        catalogView = (
            <div>
                <div className="row pl-4">
                    <div className="col-8">
                        <h5>{catalog.title}
                            <span>
                                   {
                                       catalog.title === '' ? "" :
                                           <a onClick={() => handleModalShow('edit')}
                                              id="catalog-title-badge"
                                              className="ml-3 badge badge-info"
                                              data-toggle="tooltip"
                                              title="Edit"
                                           >
                                               Edit Nama
                                           </a>
                                   }
                            </span>
                        </h5>
                        <h6>{catalog.subtitle}</h6>
                        <b>{catalog.addressName}</b>
                        <p>{catalog.addressDetails}</p>
                    </div>
                </div>
                <ProductTable
                    data={catalog.products}
                    loading={values.pageLoading}
                    categories={catalog.categories}
                    onClickEditProduct={onEditProduct}
                    onClickRemoveProduct={onRemoveProduct}
                    onClickProductStatus={onStatusProduct}
                />
            </div>

        )
    } else if (values.pageLoading) {
        catalogView = (
            <div className="p-4">loading...</div>
        )
    } else {
        catalogView = (
            <div className="text-center mt-4 pb-4">
                <div className="py-2"/>
                <h4>Anda belum punya katalog</h4>
                <p>Buat katalog untuk mempermudah penjualan Anda!</p>
                <button
                    onClick={() => handleModalShow('new')}
                    className="btn btn-primary col-3 mt-2 mb-3">
                    Buat Katalog
                </button>
            </div>
        )
    }


    return (
        <div>
            <PaymentWarning user={user} type={"top"}/>
            <div className="bg-white rounded shadow">
                <LoadingBar progress={values.progress} color='#059fe6' height={5}/>
                { modal() }
                <div className="px-4 pt-4 ">
                    <div className=" d-flex justify-content-between">
                        <div className="row container">
                            <h5>Katalog</h5>
                        </div>
                        { catalog.catalogId ?
                            <div className="d-flex">
                                <button
                                    className="btn btn-primary ml-2"
                                    onClick={() => handleModalShow('addProduct')}
                                >
                                    Tambah Produk
                                </button>
                            </div> : ''
                        }
                    </div>
                </div>
                { catalogView }
            </div>
        </div>
    )
};


export default Inventory;
